(function() {
    'use strict';

    angular
    .module('valueconnectApp')
    .controller('OriginatorNoteMessageboardController', OriginatorNoteMessageboardController);

    OriginatorNoteMessageboardController.$inject = ['$scope', 'Principal', '$state', 'order', 'notes', '$mdDialog', 'account', 'OriginatorNote', 'AlertService', '$timeout'];

    function OriginatorNoteMessageboardController ($scope, Principal, $state, order, notes, $mdDialog, account, OriginatorNote, AlertService, $timeout) {

        var vm = this;

        // Entities
        vm.order = order;
        vm.notes = notes;
        vm.account = account;
        vm.onSendNote = onSendNote;
        vm.submitOnEnter = submitOnEnter;

        vm.message = {
            appraisalOrderId: vm.order.id,
            note: '',
            read: false
        };

        vm.orderAddress = [vm.order.address.address1, vm.order.address.cityName, vm.order.address.provinceName].filter(Boolean).join(', ');

        // Methods
        vm.createNote = createNote;

        function onSendNote() {
            OriginatorNote.save(vm.message, function() {
                OriginatorNote.getNotesForAppraisal({appraisalOrderId: vm.order.id}, function(result) {
                    vm.notes = result;
                    vm.message.note = null;
                    $timeout(scrollToBottomOfMessages, 0);
                    AlertService.success('Message sent successfully.');
                });
            }, function() {
                AlertService.error('Failed to send message. Contact support if issue persists.');
            });
        }

        // The Textarea will submit the message when the user presses Enter, but not when Shift+Enter is pressed.
        function submitOnEnter(event) {
            if (event.keyCode === 13 && !event.shiftKey) {
                event.preventDefault();
                onSendNote();
            }
        }

        $timeout(scrollToBottomOfMessages, 0);
        function scrollToBottomOfMessages() {
            var messagesContainer = document.querySelector('.messages-container');
            if (messagesContainer) {
                messagesContainer.scrollTop = messagesContainer.scrollHeight;
            }
        }

        function createNote() {
            $mdDialog.show({
                templateUrl: 'app/entities/originator-note/originator-note-dialog.html',
                controller: 'OriginatorNoteDialogController',
                controllerAs: 'vm',
                clickOutsideToClose: true,
                resolve: {
                    entity: function () {
                        return {
                            note: null,
                            read: false,
                            appraisalOrderId: vm.order.id
                        };
                    }
                }
            })
            .then(
                function(data) {
                    $state.go('originator-note-messageboard', null, { reload: true });
                }, function() {
                    $state.go('originator-note-messageboard');
                }
            );
        }

    }
})();
